window.onscroll = function() {myFunction()};

var header = document.getElementById("siteHeader");
var sticky = header.offsetTop;

function myFunction() {
  if (window.pageYOffset > sticky) {
    header.classList.add("sticky_header");
  } else {
    header.classList.remove("sticky_header");
  }
}


$(document).ready(function() {
  $('.home-list-collections-slider').slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 3,
    dots: false,
    arrows: true,
    nextArrow: '<button type="button" class="slick-arrow slick-next"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 17 33" xml:space="preserve"><g id="e4eb89a6-f885-43b8-9259-0d6b1516fab0"><g id="_x38_e584754-6657-46f1-a9d8-2cfd6623b552"><g><polygon points="14.9,14.5 0,0 0,3.7 11.1,14.5 13.2,16.5 11.1,18.5 0,29.3 0,33 14.9,18.5 17,16.5 "></polygon></g></g></g></svg></button>',
    prevArrow: '<button type="button" class="slick-arrow slick-prev"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 33"><g id="7f9a1925-e8c7-4614-8787-3c6095a9f6e1" data-name="Layer 2"><g id="c9b7920a-81fa-4bfe-ad13-4da717c6854b" data-name="Layer 1"><g id="c2d982ff-0cf6-4220-b365-47f30d708fea" data-name="e4eb89a6-f885-43b8-9259-0d6b1516fab0"><g id="f51d455e-6b9c-4c4e-96db-a5004582beda" data-name="8e584754-6657-46f1-a9d8-2cfd6623b552"><polygon points="0 16.5 2.1 18.5 17 33 17 29.3 5.9 18.5 3.8 16.5 5.9 14.5 17 3.7 17 0 2.1 14.5 0 16.5"></polygon></g></g></g></g></svg></button>',
    centerMode: true,
    centerPadding: '-15px',
    responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      }
    },
      {
      breakpoint: 768,
      settings: {
        slidesToShow:1,
        slidesToScroll: 1,
        dots: true,
    arrows: false,
      }
    }
      ]
  });
  
  $('.product_image_slider').slick({
    dots: true,
    arrows: false,
    infinite: false,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1
  });
  
  var div_found = 0;
  var myInterval = setInterval(function () {
    if(div_found){
      clearInterval(myInterval);
    }else{
      if($("#insta-feed a").length > 0){
        console.log('Found');
        div_found = 1;
        setTimeout(function(){ 
          $('#insta-feed').prepend('<div class="insta-slider"></div>');
          $('#insta-feed > a').each(function () {
            if(!$(this).hasClass('instafeed-lightbox')){
              $('.insta-slider').append($(this));
            }
          });

          $('.insta-slider').slick({
            infinite: true,
            speed: 300,
            centerMode: false,
            slidesToShow: 5,
            slidesToScroll: 1,
            nextArrow: '<button type="button" class="slick-arrow slick-next"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 17 33" xml:space="preserve"><g id="e4eb89a6-f885-43b8-9259-0d6b1516fab0"><g id="_x38_e584754-6657-46f1-a9d8-2cfd6623b552"><g><polygon points="14.9,14.5 0,0 0,3.7 11.1,14.5 13.2,16.5 11.1,18.5 0,29.3 0,33 14.9,18.5 17,16.5 "></polygon></g></g></g></svg></button>',
            prevArrow: '<button type="button" class="slick-arrow slick-prev"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 33"><g id="7f9a1925-e8c7-4614-8787-3c6095a9f6e1" data-name="Layer 2"><g id="c9b7920a-81fa-4bfe-ad13-4da717c6854b" data-name="Layer 1"><g id="c2d982ff-0cf6-4220-b365-47f30d708fea" data-name="e4eb89a6-f885-43b8-9259-0d6b1516fab0"><g id="f51d455e-6b9c-4c4e-96db-a5004582beda" data-name="8e584754-6657-46f1-a9d8-2cfd6623b552"><polygon points="0 16.5 2.1 18.5 17 33 17 29.3 5.9 18.5 3.8 16.5 5.9 14.5 17 3.7 17 0 2.1 14.5 0 16.5"></polygon></g></g></g></g></svg></button>',

            responsive: [
              {
                breakpoint:1199,
                settings: {
                  slidesToShow: 3,
                  slidesToScroll:3,
                }
              },
              {
                breakpoint:991,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll:2,
                }
              },
              {
                breakpoint: 567,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1
                }
              }
            ]

          });
          $('.insta-slider .slick-slide img').each(function() {
            if( $(this).attr('src').indexOf('pixel.gif') > -1 ){
              $(this).attr('src',$(this).attr('data-src'));
            }
          });
        }, 100);
      }else{

      }
    }

  },500);
  $(document).on('click', '.product-shop .wc_product_review_top', function(){
    $('.list-tabs [data-target="#collapse-tab2"]').click();
    $('html, body').animate({ scrollTop: $('.product_bottom').offset().top - 200 }, 1000);
  });
  window.wishlist();
  if($('body.template-collection').length > 0){
   // theme.collectionGridImageSlider();
  }
});
theme.collectionGridImageSlider = function(){
  var collectionGridImageSliderCount = 0;
    var collectionGridImageSlider = setInterval(function(){
      console.log('collectionGridImageSlider calling.....')
      if($('#gf-products.product-collection .spf-product-card').length > 0){
        $('#gf-products.product-collection .spf-product-card__inner .product-grid-image').removeClass('hide');
        $('header.collection-header').detach().prependTo('#gf-grid');
        $('#gf-products.product-collection .spf-product-card').each(function(){
          var product_id = $(this).attr('data-product-id').replace('product-','');
          $('.product_image_slider-'+product_id).slick({
            dots: true,
            arrows: false,
            infinite: false,
            speed: 300,
            slidesToShow: 1,
            slidesToScroll: 1
          });


          $('.product_image_slider-'+product_id).mouseenter(function(){

            $('.product_image_slider-'+product_id).slick('unslick');
            $('.product_image_slider-'+product_id).slick({
              dots: true,
              arrows: false,
              infinite: true,
              autoplay: true,
              autoplaySpeed:1200,
              speed: 300,
              slidesToShow: 1,
              slidesToScroll: 1
            });

          });

          $('.product_image_slider-'+product_id).mouseleave(function(){

            $('.product_image_slider-'+product_id).slick('unslick');
            $('.product_image_slider-'+product_id).slick({
              dots: true,
              arrows: false,
              infinite: false,
              speed: 300,
              slidesToShow: 1,
              slidesToScroll: 1
            });

          });
        });
      	clearInterval(collectionGridImageSlider);
      }else if(collectionGridImageSliderCount > 50){
        clearInterval(collectionGridImageSlider);
      }
      collectionGridImageSliderCount++;
    }, 1000);
}
window.wishlist = function(){
  var wishListItems = localStorage.getItem('items') ? JSON.parse(localStorage.getItem('items')) : [];
  var headerWishlist = $('#siteHeader .wishlist');
  if(wishListItems.length > 0){
  	headerWishlist.addClass('whislist-added');
  }else{
    headerWishlist.removeClass('whislist-added');
  }
}


function header_height() {
    var header_height = $("header").height();
    $(".wrapper-body").css("margin-top", header_height);
}
$(document).ready(function() {
  header_height();
  $(document).on('click', '.conditions_group label', function(){
    var $parent = $(this).closest('.conditions_group');
	if($parent.find('input[name="conditions"]').prop('checked')){
      $('.conditions_group .conditions_error').remove();
    }
  });
});
$(window).resize(function(){
  header_height();
});
$('.wrapper-cart-template .btn-actions .btn-checkout').on('click', function(){
  	var $parent = $(this).closest('form');
    if(!$parent.find('input[name="conditions"]').prop('checked')){
      $('.conditions_group .conditions_error').remove();
        $('.conditions_group').append('<p class="conditions_error">Please agree all terms and conditions before placing the order.</p>');
        return false;
    }else{
        $('.conditions_group .conditions_error').remove();
    }
});
$(document).on('click', '#dropdown-cart .btn-checkout', function(){
  var $parent = $(this).closest('#dropdown-cart');
  if($parent.find('input[name="conditions"]').prop('checked')){
    $parent.find('.conditions_group .conditions_error').remove();
    window.location = $(this).data('checkout-link');
  }else{
    $parent.find('.conditions_group .conditions_error').remove();
    $parent.find('.conditions_group').append('<p class="conditions_error">Please agree all terms and conditions before placing the order.</p>');
    return false;
  }
});

//mega-menu-differntial parts
$(document).ready(function(){
  $('ul.site-nav').on('mouseover',function(){
    $('ul.site-nav-dropdown li.menu-lv-3 a').each(function(){
    	var item_link = $(this).attr('href');
      	if (item_link == '#menuitem')
        {
          $(this).addClass('sub-menu-heading');
        }
    });
  });
});

$(document).ready(function() {
   $('.collection-name').css('display','none');  
            let metaTitle = document.getElementsByClassName("product-title")[0];
            let data = metaTitle.textContent;
            let metaDesc = document.getElementsByClassName("product-short-desc")[0];
            let data2 = metaDesc.textContent;
            let metaDesc2 = document.getElementsByClassName("price on-sale")[0];
            let data3 = metaDesc2.textContent;
            $('meta[property="og:title"]').remove();
            $('meta[property="og:description"]').remove();
            $('meta[name="description"]').remove();
             document.title = `${data2} | Shop ${data} Online from ${data2} available at ShoeTree.`;
            $("head").append('<meta property="og:title" content=" ' + data2 + 'Shop ' + data + '. Online from ' + data2 + ' available at ShoeTree.">');
            $("head").append('<meta property="og:description" content="Buy ' + data + ' from ' + data2 + ' at ' + data3 + ' ShoeTree online store. 100% Original Products, Free Delivery on order above 1499.">');
            $("head").append('<title>' + data2 + ' Shop ' + data + '. Online from ' + data2 + ' available at ShoeTree.</title>');
            $("head").append('<meta name="description" content=" ' + data2 + ' Buy ' + data + ' from ' + data2 + ' at ' + data3 + ' ShoeTree online store. 100% Original Products, Free Delivery on order above 1499.">');
	          
  			 
});


